import React from 'react';
import classes from './PromoBanner.module.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PromoBanner = ({ showContinue }) => {
    const navigate = useNavigate();

    const { t } = useTranslation();

    const handleClick = () => {
        navigate("/promo/auth");
    }

    return (
        <section className={classes.promo}>
            <div className={classes.promo_top}>
                <p className={classes.promo_name}>PROMO KELASI</p>
                {/* <span className={classes.promo_dates}>7 Sep &ndash; 30 Nov</span> */}
            </div>

            <p className={classes.promo_line}>
                {t("150")}
            </p>

            {/* <div className={classes.prizes}>
                <div className={classes.prize}>
                    <p className={classes.prize_days}>{t("151")}</p>
                    <p className={classes.prize_amount}>30,000 XAF</p>
                    <p className={classes.prize_note}>{t("152")}</p>
                </div>

                <div className={`${classes.prize} ${classes.prize_double}`}>
                    <p className={classes.prize_days}>
                        {t("153")}
                        <span className={classes.prize_tag}>{t("154")}</span>
                    </p>
                    <p className={classes.prize_amount}>60,000 XAF</p>
                    <p className={classes.prize_note}>{t("155")}</p>
                </div>
            </div> */}

            {showContinue &&

                <button
                    type="button"
                    className={classes.promo_btn}
                    onClick={handleClick}
                >
                    {t("156")}
                </button>
            }

        </section>
    );
};

export default PromoBanner;